import _defineProperty from "/home/jenkins/jenkins_home/workspace/Efficience-dev/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
var _dpEtabTypesLabel;
export var ndpOrigin = {
  VITALE: 1,
  IDENTITY: 2,
  UNKNONW: 3
};
export var dpEtabTypes = {
  officine: 1,
  pui: 2,
  distributeur: 3
};
export var dpEtabTypesLabel = (_dpEtabTypesLabel = {}, _defineProperty(_dpEtabTypesLabel, dpEtabTypes.officine, 'Officine'), _defineProperty(_dpEtabTypesLabel, dpEtabTypes.pui, 'PUI'), _defineProperty(_dpEtabTypesLabel, dpEtabTypes.distributeur, 'Distributeur'), _dpEtabTypesLabel);